import { assertWidget } from '~/features-shared/libs/utils/assert'

import { APPNAME } from '~/features-generic/libs/config/widget-app-name'

/**
 * This method returns current app-key.
 * @returns current app's app-key
 */
export function getAppName() {
  let appName = APPNAME
  try {
    const _widget = window.widget
    assertWidget(_widget)
    if (typeof _widget.getAppName === 'function')
      appName = _widget.getAppName()
  }
  catch {
    return appName
  }
  return appName
}
